<!-- 任务详情组件 -->
<template>
	<div v-loading="loading">
		<el-descriptions title="基础信息">
			<el-descriptions-item label="ID">{{task.id}}</el-descriptions-item>
			<!-- <el-descriptions-item label="商家">{{task.uid_name}}</el-descriptions-item> -->
			<el-descriptions-item label="店铺">{{task.shop_id_name}}</el-descriptions-item>
			<el-descriptions-item label="平台">{{task.platform_init}}</el-descriptions-item>
			<el-descriptions-item label="国家">{{task.country_init}}</el-descriptions-item>
			<el-descriptions-item label="任务数量">{{task.task_num}}</el-descriptions-item>
			<el-descriptions-item label="已领取">{{task.draw_task_num}}</el-descriptions-item>
			<el-descriptions-item label="已完成">{{task.finish_task_num}}</el-descriptions-item>
			<!-- <el-descriptions-item label="汇率">{{task.exchange_rate}}</el-descriptions-item> -->
			<el-descriptions-item label="商品链接">
				<el-tooltip class="item" effect="dark" :content="task.goods_links" placement="top-start">
				    <el-link type="primary" :href="task.goods_links" target="_blank">点击链接</el-link>
				</el-tooltip>
			</el-descriptions-item>
			<el-descriptions-item label="商品名称">
				<el-tooltip class="item" effect="dark" :content="task.goods_name" placement="top">
					<span>{{task.goods_name | ellipsis}}</span>
				</el-tooltip>
			</el-descriptions-item>
			
			
			
			
			<el-descriptions-item label="商品主图">
				<el-image v-if="task.goods_img" style="width: 40px; height: 40px" :src="task.goods_img" fit="fill"
					:preview-src-list="[task.goods_img]">
				</el-image>
			</el-descriptions-item>
			<el-descriptions-item label="商品SKU">{{task.goods_sku}}</el-descriptions-item>
			<el-descriptions-item label="商品单价">{{task.goods_price}} {{task.coin_name}}</el-descriptions-item>
			<!-- <el-descriptions-item label="商品单价(RMB)">{{task.goods_price_rmb}}</el-descriptions-item> -->
			<el-descriptions-item label="每单数量">{{task.goods_num}}</el-descriptions-item>
			<el-descriptions-item label="任务数量">{{task.task_num}}</el-descriptions-item>
			<el-descriptions-item label="是否包邮">{{task.is_fs_init}}</el-descriptions-item>
			<!-- <el-descriptions-item label="预扣邮费">{{task.fs_money}}</el-descriptions-item> -->
			<el-descriptions-item label="创建时间">
				<span>{{ task.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="发布时间">
				<span>{{task.public_time| parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
			</el-descriptions-item>
			<el-descriptions-item label="状态">
				<el-tag :type="task.state_color">
					{{ task.state_init}}
				</el-tag>
			</el-descriptions-item>
		</el-descriptions>
		<p style="font-size: 16px;font-weight: 700;">进店方式</p>
		<p>{{task.in_shop_way_init}}</p>
		<el-table v-if="task.in_shop_way == 1" :data="task.in_keyword_data">
			<el-table-column prop="keyword" label="关键词"></el-table-column>
			<el-table-column prop="sort_init" label="排序"></el-table-column>
			<el-table-column prop="desc" label="说明"></el-table-column>
			<el-table-column prop="num" label="数量"></el-table-column>
		</el-table>
		<el-descriptions v-if="task.in_shop_way == 2" title="">
			<el-descriptions-item label="图片">
				<span v-for="(item,index) in task.in_other_data.imgs" :key="index">
					<el-image style="width: 40px; height: 40px;margin-left: 10px;" :src="item" fit="fill"
						:preview-src-list="[item]"></el-image>
				</span>
			</el-descriptions-item>
			<el-descriptions-item label="备注说明">{{task.in_other_data.desc}}</el-descriptions-item>
			<el-descriptions-item label="到期时间">{{task.in_other_data.end_time}}</el-descriptions-item>
		</el-descriptions>
		<el-descriptions title="千人千面" style="margin-top: 20px;">
			<el-descriptions-item label="店铺Follow关注">{{task.is_follow_init}}</el-descriptions-item>
			<el-descriptions-item label="产品心愿单">{{task.is_wish_init}}</el-descriptions-item>
			<el-descriptions-item label="要求加入购物车">{{task.is_car_init}}</el-descriptions-item>
			<el-descriptions-item label="Chat在线聊天">{{task.is_chat_init}}</el-descriptions-item>
		</el-descriptions>
		<el-descriptions title="增值服务" style="margin-top: 20px;">
			<el-descriptions-item label="货比数量">{{task.hb_num_init}}</el-descriptions-item>
			<el-descriptions-item label="浏览商品数量">{{task.look_num_init}}</el-descriptions-item>
			<el-descriptions-item label="搭配商品">{{task.is_collocation_init}}</el-descriptions-item>
			<el-descriptions-item label="优惠券">{{task.is_coupon_init}}</el-descriptions-item>
			<el-descriptions-item v-if="task.is_coupon == 1" label="优惠券链接">
				<el-tooltip class="item" effect="dark" :content="task.coupon_links" placement="top-start">
				    <el-link type="primary" :href="task.coupon_links" target="_blank">点击跳转</el-link>
				</el-tooltip>
			</el-descriptions-item>
		</el-descriptions>
		<div v-if="task.is_collocation == 1">
			<p>搭配商品</p>
			<el-table :data="task.collocation">
				<el-table-column prop="links" label="链接">
					<template slot-scope="{row}">
						<el-tooltip class="item" effect="dark" :content="row.links" placement="top-start">
						    <el-link type="primary" :href="row.links" target="_blank">点击跳转</el-link>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="imgs" label="图片">
					<template slot-scope="{row}">
						<span v-for="(item,index) in row.imgs" :key="index">
							<el-image style="width: 40px; height: 40px;margin-left: 10px;" :src="item" fit="fill"
								:preview-src-list="[item]"></el-image>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="price" label="价格"></el-table-column>
				<el-table-column prop="sku" label="SKU"></el-table-column>
				<el-table-column prop="price_rmb" label="价格(RMB)"></el-table-column>
			</el-table>
		</div>
		<el-descriptions title="其他" style="margin-top: 20px;">
			<el-descriptions-item label="追加红包">{{task.lucky_money}}</el-descriptions-item>
			<!-- <el-descriptions-item label="模板名称">{{task.template_name}}</el-descriptions-item> -->
			<el-descriptions-item label="留言提醒">{{task.message}}</el-descriptions-item>
		</el-descriptions>
		<!-- <el-descriptions title="任务费用预算(RMB)" style="margin-top: 20px;">
			<el-descriptions-item label="商品单价(总)">{{task.total.goods_price}}</el-descriptions-item>
			<el-descriptions-item label="基础服务费(总)">{{task.total.base_cost}}</el-descriptions-item>
			<el-descriptions-item label="增值服务费(总)">{{task.total.s_cost}}</el-descriptions-item>
			<el-descriptions-item label="追加红包(总)">{{task.total.lucky_money}}</el-descriptions-item>
			<el-descriptions-item label="预扣邮费(总)">{{task.total.fs_money}}</el-descriptions-item>
			<el-descriptions-item label="合计(总)">{{task.total.total}}</el-descriptions-item>
		</el-descriptions> -->
	</div>
</template>

<script>
	import {
		taskDetails
	} from '@/api/jd_task';
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs';
	export default {
		name: 'taskDetails',
		data() {
			return {
				loading: true,
				task: {
					'total': {}
				}
			}
		},
		props: { // 定义组件的属性
			task_id: { // 任务ID
				type: Number,
				default: 0,
			},

		},
		filters: {
			parseTime,
		},
		created() {
			this.getData();
		},
		watch: {
			task_id() { // 监听变化
				this.getData();
			}
		},
		methods: {
			getData() {
				this.loading = true;
				taskDetails(Qs.stringify({
					'task_id': this.task_id
				})).then(response => {
					this.task = response.result;
					this.loading = false;
				})
			}

		}
	}
</script>

<style>
</style>
